import React from 'react';
import classNames from 'classnames';
import { Modal, DropdownSelector, Spinner } from 'hyperdb-utils';
import { ListingObjects } from 'hyperdb-utils';
import { HyperdbListing } from '../../../../hyperdb';

class Listing extends React.Component {
  constructor(props) {
    super(props);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.submitSuccessful && nextProps.savedObject) {
      const url = `${this.props.mountedUrl}/${nextProps.savedObject.id}?propertyId=${nextProps.property.id}`;
      this.props.api.routing.redirect(this.props.router, url);
    }
  }
  render() {
    return (
      <div style={{height: '100%'}}>
        <ListingObjects
          { ...this.props }
          deleteMessage="Are you sure you want to delete this rental ruleset?"
        />
        {
          this.props.showModalCreate
            ? <Modal
                title={ `Define rental ruleset for property: ${this.props.property.name}` }
                onClose={ handleToggleModalCreate.bind(null, this.props, false) }
                onAccept={ handleSave.bind(null, this.props) }
                loading={ this.props.loading }
              >
                <Spinner show={this.props.loading} />
                <DropdownSelector
                  label="What do you want to do ?"
                  name="action"
                  value={ this.props.actionForCreate || 'create' }
                  options={ actionForCreateOptions() }
                  onChange={ handleChooseAction.bind(null, this.props) }
                />
                {
                  this.props.actionForCreate === 'copy'
                    ? <DropdownSelector
                        label="Rental rulesets"
                        name="models"
                        value={ this.props.selectedRentalRuleset }
                        options={ rentalRulesetsOptions(this.props.properties || []) }
                        onChange={ handleChooseRentalRuleset.bind(null, this.props) }
                      />
                    : null
                }
              </Modal>
            : null
        }
      </div>
    );
  }
}

function handleToggleModalCreate(props, bool, property) {
  if (bool) {
    const queryOptions = [
      ['name', 'daily_rental_ruleset'],
      {
        where: { daily_rental: true, 'daily_rental_ruleset.id': { ne: null } },
        order: { name: 'asc' },
      }
    ];
    props.api.rentalRuleset.getObjects({ queryOptions, propName: 'properties' });
    props.api.rentalRuleset.setData({ showModalCreate: bool, property, actionForCreate: 'create', selectedRentalRuleset: null });
  } else {
    props.api.rentalRuleset.setData({ showModalCreate: bool });
  }
}
function actionForCreateOptions() {
  return [
    { name: 'Create new model', value: 'create' },
    { name: 'Copy existing model', value: 'copy' },
  ];
}
function handleChooseAction(props, field) {
  const { name, value } = field;
  props.api.rentalRuleset.setData({ actionForCreate: value });
}
function handleSave(props) {
  switch (props.actionForCreate) {
  case 'copy':
    if (props.selectedRentalRuleset) {
      props.api.rentalRuleset.copyModelForProperty({ propertyId: props.property.id, modelId: props.selectedRentalRuleset });
      handleToggleModalCreate(props, false);
    }
    break;
  case 'create':
  default:
    props.api.routing.redirect(props.router, `${props.mountedUrl}/new?propertyId=${props.property.id}`);
    handleToggleModalCreate(props, false);
  }
}

function rentalRulesetsOptions(properties) {
  return properties.map(p => ({ name: p.name, value: p.daily_rental_ruleset.value[1] }));
}
function handleChooseRentalRuleset(props, field) {
  const { name, value } = field;
  props.api.rentalRuleset.setData({ selectedRentalRuleset: value });
}

Listing.propTypes = {
  api: React.PropTypes.object,
  loading: React.PropTypes.bool,
  showModalCreate: React.PropTypes.bool,
  actionForCreate: React.PropTypes.string,
  property: React.PropTypes.object,
  properties: React.PropTypes.array,
};

export default HyperdbListing({
  CustomComponent: Listing,
  collectionName: 'daily_rental_rulesets',
  namespace: 'rentalRuleset',
  mountedUrl: '/daily-rental/rental-rulesets',
  title: 'Rental rulesets',
  columns: [
    { attribute: 'name', label: 'property' },
    { label: 'defined', sortable: false, value: (object) => !!object.daily_rental_ruleset.value[1] ? <i className="fas fa-check" /> : null },
  ],
  canCreate: false,
  canDelete: (object) => !!object.daily_rental_ruleset.value[1],
  onEdit: (object, props) => {
    if (!object.daily_rental_ruleset.value[1]) {
      handleToggleModalCreate(props, true, object);
    } else {
      props.api.routing.redirect(props.router, `/daily-rental/rental-rulesets/${object.daily_rental_ruleset.value[1]}?propertyId=${object.id}`);
    }
  },
  onDelete: (object, props) => {
    props.api.rentalRuleset.deleteObject(object.daily_rental_ruleset.value[1]);
  },
});



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/rental-ruleset/containers/Listing.jsx